export default "__VITE_ASSET__B2WsU9Vo__"